import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface CarrierShipmentConfigRequestParams {
  customerKey: number;
}

export const getCarrierShipmentConfigAPI = (params: CarrierShipmentConfigRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/settings/fields/$carrier-search`,
  });
};

export type CarrierShipmentConfigResponse = {
  customerKey: number;
  columnName: string;
  moduleName: string;
  isVisible: 0 | 1;
}[];

export const fetchCarrierShipmentConfig = async (
  params: CarrierShipmentConfigRequestParams,
): Promise<CarrierShipmentConfigResponse> => {
  const response: AxiosResponse<CarrierShipmentConfigResponse> = await getCarrierShipmentConfigAPI(params);
  return response.data;
};
